import React from "react"

import ReactPaginate from "react-paginate"
import { Col, Row } from "react-bootstrap"

import RightChevron from "../../images/icons/right-chevron.png"

import "./paginator.scss"

const Paginator = props => {
  const pageChange = data => {
    props.setCurrentPage(data.selected)
  }

  const renderPreviousLabel = () => {
    return (
      <div className="left-arrow">
        <img src={RightChevron} alt="left-chevron" />
      </div>
    )
  }

  const renderNextLabel = () => {
    return (
      <div className="right-arrow">
        <img src={RightChevron} alt="right-chevron" />
      </div>
    )
  }

  return (
    <Row>
      <Col lg="12">
        <div
          className={`${props.style ? props.style : ""} paginator-container`}
        >
          <ReactPaginate
            pageCount={props.pageCount}
            pageRangeDisplayed={props.pageRangeDisplayed}
            marginPagesDisplayed={props.marginPagesDisplayed}
            initialPage={props.initialPage}
            forcePage={props.currentPage || 0}
            previousLabel={renderPreviousLabel()}
            nextLabel={renderNextLabel()}
            onPageChange={pageChange}
          />
        </div>
      </Col>
    </Row>
  )
}

export default Paginator
